<template>
  <div class="kits-container" :class="profileData.user_type == 'parent' && kitsOwned && 'kits-container-parent'">
    <div class="title-container">
      <div class="title">Kits Owned</div>
        <button class="utility"  v-if="kitsOwned && accessProfile" style="outline: none" @click="add=true; openModal=true;" >
          <img class="space" src="https://images.avishkaar.cc/misc/profile/utility/add-icon.png" alt="Add" />
        <div class="span">Add More</div>
      </button>
    </div>
    <div class="no-kits"  v-if="!kitsOwned">
      <div class="sub-title">Already have a kit ?</div>
      <button class="orange-button" @click="openModal=true; add=true;">Add Now</button>
      <div class="content-container">
        <div class="content"> Don't have kit yet? Take this 2 mins quiz to find out your perfect kit or course. 
          <button @click="showModal" style="outline:none;"><span class="highlight">Take Quiz</span></button>
        </div>
      </div>
    </div>
    <div class="kits-added" v-if="kitsOwned" :class="profileData.user_type == 'parent' && 'kits-added-parent'">
      <div class="kit-card" :key="index" v-for="(proData,index) in kitsOwned" :style="'border-color:#' + (!proData.product_details.skillData ? proData.product_details.defaultColor : proData.product_details.skillData.skill_color) + ';background-color:#' + (!proData.product_details.skillData ? proData.product_details.defaultColor : proData.product_details.skillData.skill_color)" :class="[!accessProfile && 'kit-card-no-access', profileData.user_type == 'parent' && 'kit-card-parent']">
        <div class="kit-head" :class="profileData.user_type == 'parent' && 'kit-head-parent'">{{proData.product_details.skill}}</div>
        <div class="kit-details" :class="profileData.user_type == 'parent' && 'kit-details-parent'">
          <img :src="proData.product_details.image" class="kit-img" alt="" width="125" height="100" />
          <div class="kit-name">{{proData.product_details.product_name}}</div>
        </div>
        <div class="kit-rating-parent" v-if="profileData.user_type == 'parent'">
          <div class="kit-rating-details">
            <div class="kit-star"><span style="margin:0 0.2rem;" v-for="index in (userReviews ? (userReviews.filter(a=>a.related_id == proData.product_details.product_code).length ? userReviews.filter(a=>a.related_id == proData.product_details.product_code)[0].rating : 0) : 0)" :key="index+10"><img src="https://images.avishkaar.cc/misc/profile/utility/star-icon.png" alt="Star" /></span><span style="margin:0 0.2rem;" v-for="index in (5 - (userReviews ? (userReviews.filter(a=>a.related_id == proData.product_details.product_code).length ? userReviews.filter(a=>a.related_id == proData.product_details.product_code)[0].rating : 0) : 0))" :key="index+20"><img src="https://images.avishkaar.cc/misc/profile/utility/star-no-fill-icon.png" alt="Star" /></span></div>
            <div class="kit-rate">{{(userReviews ? (userReviews.filter(a=>a.related_id == proData.product_details.product_code).length ? userReviews.filter(a=>a.related_id == proData.product_details.product_code)[0].rating : 0) : 0) + '/5'}}</div>
          </div>
          <div class="kit-review" v-if="accessProfile && (userReviews ? (userReviews.filter(a=>a.related_id == proData.product_details.product_code).length ? false : true) : true)" @click="details=proData.product_details; openModal=true; rate=true;">Write a Review</div>
          <div class="kit-review" v-else-if="accessProfile && (userReviews ? (userReviews.filter(a=>a.related_id == proData.product_details.product_code).length ? true : false) : false)" @click="editClick(proData.product_details)">Edit Review</div>
          <a :href="'https://shop.avishkaar.cc/products/' + proData.product_details.product_uri" v-else><div class="kit-review">Read All Review</div></a>
        </div>
      </div>
    </div>
    <img class="kit-card-prev" :class="[loggedIn.username != null && 'logged-prev', !accessProfile && 'kit-card-prev-no-access']" src="https://images.avishkaar.cc/misc/profile/utility/next-icon.png" alt="Previous" @click="prevKit" v-if="kitsOwned ? (kitsOwned.length > 4 ? true : false) : false" />
    <img class="kit-card-next" :class="!accessProfile && 'kit-card-next-no-access'" src="https://images.avishkaar.cc/misc/profile/utility/next-icon.png" alt="Next" @click="nextKit" v-if="kitsOwned ? (kitsOwned.length > 4 ? true : false) : false" />
    <v-dialog v-model="openModal" width="unset" persistent :fullscreen="$vuetify.breakpoint.width < 700 && true">
      <div class="dialog-add-kit-container" v-if="add">
        <div class="dialog-title-container">
          <div class="title">Add Kits</div>
          <button style="outline: none" @click="add=false; openModal=false;">
            <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Cancel" />
          </button>
        </div>
        <div class="form-kit-container">
          <v-text-field hide-details class="input-kit" label="Kit Code" outlined @focus="focusIn" @blur="focusOut" :class="searchKits && checkEpochKey && checkEpochKey.product_details && 'input-kit-focus'" v-on:keyup="toCheckEpoch(searchValue)" v-model="searchValue">
            <template v-slot:append>
              <img src="https://images.avishkaar.cc/misc/profile/utility/qr-code-icon.png" alt="Scan"/>
            </template>
          </v-text-field>
          <div class="search-kits-container" v-if="searchKits && checkEpochKey && checkEpochKey.product_details">
            <div class="searched">
              <div class="searched-item">
                <img :src="checkEpochKey.product_details.image" alt="Image" width="50" height="40" :class="checkEpochKey.epoch_reg_details && 'searched-image-already'" />
                <div class="searched-title" :class="checkEpochKey.epoch_reg_details && 'searched-title-already'">{{checkEpochKey.product_details.product_name}}</div>
              </div>
              <div class="search-action" v-if="!checkEpochKey.epoch_reg_details"  @click="registerProduct(checkEpochKey.product_epoch,checkEpochKey.product_code);add=false; success=true;">Add</div>
              <div class="search-action search-action-already" v-else-if="checkEpochKey.epoch_reg_details">Already Registered</div>
            </div>
          </div>
          <div v-else-if="searchKits && !checkEpochKey && searchValue!=''" class="invalid-code">Invalid Kit Code</div>
          <div class="help-container">
            <div class="sub-title">Facing Issues while adding your Avishkaar kits ?</div>
            <div class="content-container">
              <div class="content">Feel free to get in touch with us. <span class="highlight" @click="showRequestCall('Facing Issues while adding Avishkaar kits!')"> Request a call </span></div>
            </div>
            <RequestCall :head="requestCallHead" />
          </div>
        </div>
      </div>
      <div class="success-kits" v-if="success">
        <div class="cancel-success-kits">
          <button style="outline: none" @click="success=false; openModal=false;">
            <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Cancel" />
          </button>
        </div>
        <div>
          <div class="success-title">Your Kits Has Been Added Successfully!</div>
          <div class="success-content"> Dont't forget to explore <span class="highlight"> more awesome kits </span> from Avishkaar.</div>
        </div>
      </div>
      <div class="rate-kit" v-if="rate && details">
        <div class="rate-kit-title-container">
          <div class="title">Product Review</div>
          <button style="outline: none" @click="rate=false; openModal=false; edit=false; details=null; rating.star=0; rating.description=null">
            <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Cancel" />
          </button>
        </div>
        <div class="rate-kit-body">
          <div class="rate-top">
            <img class="rate-img" :src="details.image" />
            <div class="rate-product">
              <div class="rate-product-title">Rate This Product</div>
              <div class="stars">
                <img class="star" @click="rating.star=1" :src="'https://images.avishkaar.cc/misc/profile/utility/' + (rating.star > 0 ? 'star-icon.png' : 'star-no-fill-icon.png')" alt="Star" />
                <img class="star" @click="rating.star=2" :src="'https://images.avishkaar.cc/misc/profile/utility/' + (rating.star > 1 ? 'star-icon.png' : 'star-no-fill-icon.png')" alt="Star" />
                <img class="star" @click="rating.star=3" :src="'https://images.avishkaar.cc/misc/profile/utility/' + (rating.star > 2 ? 'star-icon.png' : 'star-no-fill-icon.png')" alt="Star" />
                <img class="star" @click="rating.star=4" :src="'https://images.avishkaar.cc/misc/profile/utility/' + (rating.star > 3 ? 'star-icon.png' : 'star-no-fill-icon.png')" alt="Star" />
                <img class="star" @click="rating.star=5" :src="'https://images.avishkaar.cc/misc/profile/utility/' + (rating.star > 4 ? 'star-icon.png' : 'star-no-fill-icon.png')" alt="Star" />
              </div>
            </div>
          </div>
          <div class="rate-kit-description">
            <v-textarea label="Add a Review" autocomplete="off" rows="7" v-model="rating.description" outlined hide-details no-resize auto-grow />
          </div>
        </div>
        <div class="rate-kit-footer">
          <button class="orange-button" :class="$v.rating.$invalid ? 'disabled-button' : null" :disbaled="$v.rating.$invalid ? true : false" @click="editReview" v-if="edit">Edit</button>
          <button class="orange-button" :class="$v.rating.$invalid ? 'disabled-button' : null" :disbaled="$v.rating.$invalid ? true : false" @click="addReview" v-else>Save</button>
        </div>
      </div>
    </v-dialog>
    <productFinder />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
const Star = (value) => {
  if (value > 0) {
    return true;
  } else {
    return false;
  }
}
const productFinder = () => import('@/components/microComponents/productFinder');
const RequestCall = () => import('@/components/requestCall');
export default {
  name: "Kits",
  props: ["accessProfile"],
  components : { productFinder, RequestCall },
  mixins: [validationMixin],
  data() {
    return {
      openModal: false,
      add: false,
      success: false,
      searchKits: false,
      rate: false,
      edit: false,
      details: null,
      searchValue: null,
      requestCallHead: null,
      rating: {
        star: 0,
        description: null
      }
    };
  },
  validations: {
    rating: {
      star: { Star },
      description: { required, minLength: minLength(10) }
    }
  },
  computed: {
    ...mapGetters({ kitsOwned:"getKitsOwned", checkEpochKey:"getcheckEpochKey", profileData: "getUserProfileData", loggedIn: "getUserDetails", userReviews: "getFetchUserReviews" }),
  },
  methods: {
    ...mapActions(["fetchEpochKeyCheck","registerProductByProfile","addUserReview","fetchUserReviews","editUserReview"]),
    showModal() {
        this.$emit('openModal')
    },
    focusIn() {
      this.searchKits = true;
      if(this.searchValue != '') this.toCheckEpoch(this.searchValue);
    },
    focusOut() {
      setTimeout(()=>{
        this.searchKits = false;
        this.checkEpochKey.product_details = null;
        },500)
    },
    toCheckEpoch(val) {
      if(val.length>18)
        this.fetchEpochKeyCheck(val);
    },
    registerProduct(epoch,productCode) {
      const payLoad={
        "productEpoch":epoch,
        "productCode":productCode,
        "api_key":"$2a$08$au3osMSeEIJP5xfArdArYOdaDnf7JXOc355RsOoVaqcCrhGhY3Nee"
      }
      this.registerProductByProfile(payLoad);
    },
    showRequestCall(head) {
      this.requestCallHead = head
      this.$root.$emit('bv::show::modal', 'requestCallModal', '#btnShow')
    },
    nextKit() {
      var card = document.getElementsByClassName("kit-card")[0];
      var style = card.currentStyle || window.getComputedStyle(card), width = card.offsetWidth, margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      document.getElementsByClassName("kits-added")[0].scrollLeft += width + margin;
    },
    prevKit() {
      var card = document.getElementsByClassName("kit-card")[0];
      var style = card.currentStyle || window.getComputedStyle(card), width = card.offsetWidth, margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      document.getElementsByClassName("kits-added")[0].scrollLeft -= width + margin;
    },
    addReview() {
      let payload = {
        userId: this.loggedIn.user_id,
        name: null,
        relatedId: this.details.product_code,
        relatedTo: this.details.category,
        rating: this.rating.star,
        description: this.rating.description,
      }
      this.addUserReview(payload).then(response => {
        if(response.data.status == 'success') {
          this.rate = false;
          this.details = null;
          this.rating.star = 0;
          this.rating.description = null;
          this.openModal = false;
          this.fetchUserReviews(this.loggedIn.user_id);
        }
      });
    },
    editReview() {
      let payload = {
        review_id: this.details.id,
        rating: this.rating.star,
        description: this.rating.description,
      }
      this.editUserReview(payload).then(response => {
        if(response.data.status == 'success') {
          this.rate = false;
          this.details = null;
          this.rating.star = 0;
          this.rating.description = null;
          this.openModal = false;
          this.edit = false;
          this.fetchUserReviews(this.loggedIn.user_id);
        }
      });
    },
    editClick(value) {
      this.details = this.userReviews.filter(a=>a.related_id == value.product_code)[0];
      this.details.image = value.image;
      this.openModal = true;
      this.rating.star = this.details.rating;
      this.rating.description = this.details.description;
      this.rate = true;
      this.edit = true;
    }
  },
  watch: {
    loggedIn: function(value) {
      if(value) {
        this.fetchUserReviews(value.user_id);
      }
    }
  },
};
</script>

<style lang="scss">
.kits-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 9%;
  justify-content: center;
  width: 100%;
  height: 60vh;
  .title-container {
    display: flex;
    width: 85%;
    align-items: center;
    justify-content: space-between;
    margin: 1.7% 0;
    .title {
      font-family: Poppins;
      font-size: 1.5rem;
      font-weight: 600;
      color: #000000;
    }
    .utility {
      display: flex;
      align-items: center;
      justify-content: center;
      .space {
        margin: 0 5px;
      }
      .span {
        font-family: Poppins;
        font-size: 1.25rem;
        font-weight: 500;
        color: #f36f2e;
      }
    }
  }
  .no-kits {
    display: flex;
    margin: 1.7% 0;
    flex-direction: column;
    align-items: center;
    padding: 0 5%;
    justify-content: space-evenly;
    width: 85%;
    height: 50%;
    border: 1px solid #cacaca;
    border-radius: 8px;
    .sub-title {
      font-family: Poppins;
      font-size: 1.25rem;
      font-weight: 600;
      color: #373737;
    }
    .orange-button {
      width: 30%;
      height: 20%;
      font-family: Roboto;
      outline: 0;
      font-size: 1rem;
      font-weight: 500;
      background: #f36f2e;
      box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
      border: 1px solid #f36f2e;
      box-sizing: border-box;
      border-radius: 30px;
      color: white;
    }
    .content-container {
      display: flex;
      align-items: center;
      justify-content: center;
      .content {
        font-family: Poppins;
        font-size: 1rem;
        font-weight: 500;
        color: #151515;
        .highlight {
          margin-left: 5px;
          font-family: Roboto;
          font-size: 1rem;
          font-weight: 700;
          color: #f36f2e;
        }
      }
    }
  }
  .kits-added {
    display: flex;
    margin: 1.7% 0;
    align-items: center;
    justify-content: flex-start;
    overflow: auto;
    scroll-behavior: smooth;
    width: 85%;
    height: 55%;
    .kit-card {
      display: flex;
      width: 23.5%;
      flex-direction: column;
      align-items: center;
      border-radius: 15px;
      flex-shrink: 0;
      margin-right: 2%;
      border: 1px solid;
      height: 100%;
      .kit-head {
        display: flex;
        align-items: center;
        text-transform: uppercase;
        justify-content: center;
        height: 20%;
        font-family: Poppins;
        width: 100%;
        font-size: 1.25rem;
        font-weight: 600;
        color: #ffffff;
      }
      .kit-details {
        display: flex;
        align-items: center;
        flex-direction: column;
        background-color: #ffffff;
        width: 100%;
        justify-content: space-evenly;
        border-radius: 0 0 15px 15px;
        height: 80%;
        .kit-name {
          font-family: Poppins;
          font-size: 1.125rem;
          font-weight: 600;
          color: #000000;
        }
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
    .kit-card-no-access {
      width: 23.5%;
      margin-right: 2%;
    }
  }
  .kits-added::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
  }
  .kits-added::-webkit-scrollbar-thumb {
    border-radius: none;
    box-shadow: none;
    background-color: transparent;
  }
  .kit-card-prev {
    position: absolute;
    transform: rotate(180deg);
    margin-top: 5rem;
    left: calc(3% + 76px);
    cursor: pointer;
  }
  .kit-card-next {
    position: absolute;
    right: 6%;
    margin-top: 5rem;
    cursor: pointer;
  }
  .kit-card-prev-no-access {
    left: 3%;
  }
  .logged-prev {
    left: calc(3% + 76px);
  }
}
.kits-container-parent {
  height: 80vh;
  .kits-added-parent {
    height: 60%;
    .kit-card-parent {
      height: 100%;
      .kit-head-parent {
        height: 13%;
      }
      .kit-details-parent {
        height: 49%;
        border-radius: initial;
      }
      .kit-rating-parent {
        height: 38%;
        background: #ffffff;
        width: 100%;
        border-radius: 0 0 15px 15px;
        .kit-rating-details {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 60%;
          .kit-star {
            margin: 0.5rem 0 0.25rem 0;
          }
          .kit-rate {
            margin: 0.25rem 0 0.5rem 0;
            font-family: Roboto;
            font-size: 1rem;
            font-weight: 500;
            color: #000000;
          }
        }
        .kit-review {
          display: flex;
          align-items: center;
          justify-content: center;
          border-top: 1px solid #f0f0f0;
          font-family: Roboto;
          font-size: 1rem;
          height: 40%;
          font-weight: 500;
          color: #f36f2e;
          cursor: pointer;
        }
      }
    }
  }
}
.dialog-add-kit-container {
  background: #ffffff;
  width: 60vw;
  height: 80vh;
  .dialog-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2%;
    border-bottom: 1px solid rgb(0, 0, 0, 0.07);
    .title {
      font-family: Poppins;
      font-size: 1.5rem;
      font-weight: 600;
      color: #000000;
    }
  }
  .form-kit-container {
    padding: 2%;
    .v-input--is-focused {
      .theme--light.v-label--active {
        color: #f36f2e;
        top: 15px;
      }
    }
    .input-kit {
      color: #f36f2e;
      border-radius: 10px;
      .theme--light.v-label--active {
        top: 15px;
      }
      input {
        font-family: Roboto;
        font-size: 1.125rem;
        font-weight: 400;
      }
    }
    .input-kit-focus {
      border-radius: 10px 10px 0 0;
    }
    .v-text-field--outlined legend {
      margin-left: 0.9rem;
    }
    .search-kits-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 56px;
      width: 100%;
      border: 2px solid #f36f2e;
      border-top: none;
      border-radius: 0 0 10px 10px;
      .searched {
        display: flex;
        align-items: center;
        padding: 0 10px;
        width: 100%;
        justify-content: space-between;
        .searched-item {
          display: flex;
          align-items: center;
          justify-content: center;
          .searched-title {
            margin-left: 1rem;
            font-family: Roboto;
            font-size: 0.875rem;
            font-weight: 500;
            color: #303030;
          }
          .searched-image-already {
            opacity: 0.50 !important;
          }
          .searched-title-already {
            opacity: 0.50 !important;
          }
        }
        .search-action {
          font-family: Roboto;
          font-size: 1rem;
          font-weight: 500;
          color: #f36f2e;
          cursor: pointer;
        }
        .search-action-already {
          cursor: initial;
          color: #f94244;
        }
      }
    }
    .invalid-code {
      font-family: Roboto;
      font-size: 1rem;
      font-weight: 500;
      color: #f94244;
      padding: 0.5rem;
    }
    .help-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 40vh;
      .sub-title {
        font-family: Poppins;
        font-size: 1.25rem;
        font-weight: 500;
        color: #151515;
        margin: 0.5rem 0;
      }
      .content-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0.5rem 0;
        .content {
          font-family: Roboto;
          font-size: 1rem;
          font-weight: 400;
          color: #151515;
          .highlight {
            cursor: pointer;
            margin-left: 5px;
            font-family: Roboto;
            font-size: 1rem;
            font-weight: 500;
            color: #f36f2e;
          }
        }
      }
    }
  }
}
.success-kits {
  background: url("https://images.avishkaar.cc/misc/profile/images/success-image.png");
  background-size: 100% 100%;
  flex-direction: column;
  background-position: center;
  width: 60vw;
  height: 80vh;
  display: flex;
  align-items: center;
  padding-bottom: 12%;
  justify-content: space-between;
  .cancel-success-kits {
    display: flex;
    align-items: center;
    padding: 2%;
    width: 99%;
    justify-content: flex-end;
  }
  div {
    .success-title {
      font-family: Poppins;
      font-size: 1.5rem;
      margin: 0.5rem 0;
      font-weight: 600;
      color: #9bc157;
    }
    .success-content {
      font-family: Roboto;
      font-size: 1rem;
      margin: 0.5rem 0;
      font-weight: 400;
      color: #868686;
      .highlight {
        color: #f36f2e;
      }
    }
  }
}
.rate-kit {
  background: #ffffff;
  width: 60vw;
  height: 80vh;
  .rate-kit-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2%;
    height: 15%;
    border-bottom: 1px solid rgb(0, 0, 0, 0.07);
    .title {
      font-family: Poppins;
      font-size: 1.5rem;
      font-weight: 600;
      color: #000000;
    }
  }
  .rate-kit-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 70%;
    padding: 2%;
    .rate-top {
      display: flex;
      align-items: center;
      width: 100%;
      border-bottom: 1px solid #F0F0F0;
      padding-bottom: 2%;
      .rate-img {
        width: auto;
        height: 80px;
        padding-right: 3rem;
        border-right: 1px solid #F0F0F0;
      }
      .rate-product {
        display: flex;
        flex-direction: column;
        padding-left: 3rem;
        .rate-product-title {
          font-family: Poppins;
          font-weight: 600;
          font-size: 1.125rem;
          color: #000000;
        }
        .stars {
          display: flex;
          align-items: center;
          .star {
            cursor: pointer;
            margin: 0.3rem;
          }
        }
      }
    }
    .rate-kit-description {
      margin-top: 1.5rem;
      width: 100%;
      .v-text-field--outlined legend {
        margin-left: 1.4rem;
      }
    }
  }
  .rate-kit-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 15%;
    padding: 2%;
    border-top: 1px solid #DBDBDB;
    .orange-button {
      width: 50%;
      padding: 0.75rem 0;
      font-family: Roboto;
      outline: 0;
      font-size: 1rem;
      font-weight: 500;
      background: #f36f2e;
      box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
      border: 1px solid #f36f2e;
      box-sizing: border-box;
      border-radius: 30px;
      color: white;
    }
    .disabled-button {
      background-color: #A0A0A0;
      border: 1px solid #A0A0A0;
    }
  }
}
@media all and (max-width: 1000px) {
  .kits-container {
    .kits-added {
      .kit-card {
        width: 32%;
      }
    }
  }
  .dialog-add-kit-container {
    width: 80vw;
  }
  .rate-kit {
    width: 80vw;
  }
  .success-kits {
    width: 80vw;
    .cancel-success-kits {
      padding: 5%;
    }
    div {
      padding: 0 5%;
    }
  }
}
@media all and (max-width: 700px) {
  .kits-container {
    align-items: center;
    padding-left: 0;
    .title-container {
      margin: 3% 0;
      width: 90%;
      .title {
        font-size: 1.25rem;
      }
      .utility {
        .span {
          font-size: 1.125rem;
        }
      }
    }
    .no-kits {
      margin: 3% 0;
      width: 90%;
      .sub-title {
        font-size: 1.125rem;
        font-weight: 500;
      }
      .orange-button {
        width: 70%;
        height: 25%;
      }
      .content-container {
        .content {
          font-size: 0.875rem;
          .highlight {
            font-size: 0.875rem;
          }
        }
      }
    }
    .kits-added {
      margin: 3% 0;
      overflow: auto;
      width: 90%;
      height: 60%;
      .kit-card {
        width: 80%;
        .kit-head {
          font-size: 1rem;
        }
        .kit-details {
          .kit-name {
            font-size: 1rem;
          }
        }
      }
    }
    .kit-card-prev {
      display: none;
    }
    .kit-card-next {
      display: none;
    }
  }
  .kits-container-parent {
    height: 80vh;
    .kits-added-parent {
      height: 70%;
      .kit-card-parent {
        height: 100%;
        .kit-head-parent {
          height: 13%;
        }
        .kit-details-parent {
          height: 49%;
        }
        .kit-rating-parent {
          height: 38%;
          .kit-rating-details {
            height: 60%;
          }
          .kit-review {
            height: 40%;
          }
        }
      }
    }
  }
  .dialog-add-kit-container {
    width: 100vw;
    height: 100vh;
    .dialog-title-container {
      padding: 5%;
      .title {
        font-size: 1.25rem;
      }
    }
    .form-kit-container {
      padding: 5%;
      .input-kit {
        color: #f36f2e;
        .theme--light.v-label--active {
          color: #f36f2e;
        }
      }
      .v-text-field--outlined legend {
        margin-left: 0.9rem;
      }
      .help-container {
        .sub-title {
          font-size: 1.125rem;
        }
        .content-container {
          .content {
            font-size: 0.875rem;
            .highlight {
              font-size: 0.875rem;
            }
          }
        }
      }
    }
  }
  .success-kits {
    background: url("https://images.avishkaar.cc/misc/profile/images/success-image-mobile.png");
    background-size: 100% 100%;
    background-position: center;
    width: 100vw;
    height: 100vh;
    div {
      margin-bottom: 3rem;
      .success-title {
        font-size: 1.25rem;
      }
    }
  }
  .rate-kit {
    width: 100vw;
    height: 100vh;
    .rate-kit-title-container {
      padding: 5%;
      .title {
        font-size: 1.25rem;
      }
    }
    .rate-kit-body {
      padding: 5%;
      .rate-top {
        padding-bottom: 5%;
        .rate-img {
          padding-right: 1rem;
        }
        .rate-product {
          padding-left: 1rem;
          .rate-product-title {
            font-size: 1rem;
          }
        }
      }
    }
    .rate-kit-footer {
      padding: 5%;
    }
  }
}
</style>
<style lang="scss">
.rate-kit {
  .theme--light {
    color: #ABABAB !important;
    input {
      color: #303030 !important;
    }
  }
  .theme--light.v-input {
    color: #ABABAB !important;
    caret-color: #ABABAB !important;
  }
  .theme--light.v-label {
    color: #ABABAB !important;
  }
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    color: #ABABAB !important;
    border: 1px solid rgba(163, 163, 163, 0.32) !important;
    border-radius: 4px !important;
  }
  .v-text-field--outlined.v-input--is-focused fieldset, .v-text-field--outlined.v-input--has-state fieldset {
    border: 1px solid rgba(163, 163, 163, 0.32) !important;
    border-radius: 4px !important;
  }
}
</style>